// src/pages/Hakkimizda.js
import React from 'react';
import {
  Box, Container, Typography, Grid, Paper, List, ListItem, ListItemIcon, ListItemText,
  Accordion, AccordionSummary, AccordionDetails, Button, Stack, Divider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneIcon from '@mui/icons-material/Phone';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';

const ABOUT = {
  seo: {
    metaDescription: "İrem Oto, 25 yılı aşkın tecrübesiyle Ankara Yenimahalle Renault ve Dacia yedek parça uzmanı. Orijinal ve muadil 1400+ parça, doğru parça, uzman destek.",
    keywords: "irem oto, irem oto renault, ankara renault yedek parça, ankara dacia yedek parça, yenimahalle renault parça, renault yedek parça ankara, dacia yedek parça ankara, renault clio yedek parça, dacia duster yedek parça, orijinal renault parça, muadil renault parça, irem otomotiv",
  },
  h1: "İrem Oto: 25 Yılı Aşkın Tecrübeyle Renault ve Dacia Yedek Parça Uzmanı",
  heroSubtitle: "Çeyrek asrı aşkın deneyimimizle Ankara Yenimahalle'den tüm Türkiye'ye, Renault ve Dacia için orijinal ve muadil yedek parça çözümleri sunuyoruz. İrem Oto, doğru parçayı ilk seferde bulmanın adresidir.",
  highlights: [
    { stat: "25+", label: "Yıl Sektör Tecrübesi" },
    { stat: "1400+", label: "Farklı Ürün Çeşidi" },
    { stat: "Renault & Dacia", label: "Tam Marka Uzmanlığı" },
    { stat: "Yenimahalle / Ankara", label: "Merkez Sanayi Sitesi" },
  ],
  sections: [
    {
      heading: "Biz Kimiz? 25 Yılı Aşkın Bir Yolculuk",
      paragraphs: [
        "İrem Oto, resmî adıyla İrem Otomotiv, 25 yılı aşkın süredir Renault ve Dacia yedek parça sektöründe faaliyet gösteren, alanında uzmanlaşmış köklü bir işletmedir. Çeyrek asrı aşan bu süreçte tek bir hedefimiz oldu: araç sahiplerini ve esnafı doğru parçayla, doğru fiyatla ve güler yüzle buluşturmak.",
        "Bizim için yedek parça satışı, yalnızca bir kutuyu raftan indirmek değildir. Yılların getirdiği birikimle hangi modelin hangi parçaya ihtiyaç duyduğunu, bir parçanın o araca uyup uymayacağını ve müşterinin gerçekte neye ihtiyacı olduğunu en baştan doğru anlamaktır. Bu yaklaşım, müşterilerimizin yanlış parça alıp zaman ve para kaybetmesinin önüne geçer.",
        "Ankara Yenimahalle'deki dükkanımıza ilk gün gelen müşterimize gösterdiğimiz titizliği, bugün gelen müşterimize de aynen gösteriyoruz. Güven, bizim en büyük sermayemiz; yıllardır süren müşteri ilişkilerimiz ve tekrar tekrar bize dönen araç sahipleri, bu güvenin en somut kanıtıdır. İrem Oto'da müşteri memnuniyeti bir slogan değil, 25 yıldır sürdürdüğümüz bir çalışma biçimidir.",
      ],
    },
    {
      heading: "Renault & Dacia Uzmanlığı: Tek Bir İşi En İyi Şekilde Yapmak",
      paragraphs: [
        "İrem Oto olarak gücümüzü uzmanlaşmaktan alıyoruz. Her marka ve her modelle uğraşmak yerine, kendimizi tamamen Renault ve Dacia ekosistemine adadık. 'Renault ve Dacia grubunda varız' yaklaşımımız, bu iki markanın tüm inceliklerine, model farklılıklarına ve yıllara göre değişen parça yapılarına hakim olmamızı sağlıyor.",
        "Renault ve Dacia; motor, şasi ve birçok parça paylaşımında ortak bir platform kullanır. Bu iki markayı bir arada, derinlemesine bilmek; bir Clio'nun farklı kasalarındaki parça farklarını, bir Megane'in motor tipine göre değişen filtresini ya da bir Duster ile Logan arasındaki ortak ve farklı parçaları doğru ayırt edebilmek demektir. İşte bu uzmanlık, müşterimize 'doğru parçayı ilk seferde' verme garantimizin temelidir.",
        "Bir aracın yıl, kasa tipi ve motor bilgisini öğrenip o araca tam uyan parçayı bulmak, yılların getirdiği bir tecrübe işidir. İrem Oto'da telefonda ya da tezgah başında size sorduğumuz her soru, size yanlış parça satmamak içindir. Renault ve Dacia konusundaki bu odaklanmış uzmanlık, 'İrem Oto Renault' aradığınızda karşınıza çıkmamızın ve bizi Ankara'da bu alanda tercih edilen bir adres haline getirmemizin de temel nedenidir.",
      ],
    },
    {
      heading: "Geniş Ürün Gamımız: 1400+ Parça, Orijinal ve Muadil Seçenekler",
      paragraphs: [
        "İrem Oto'nun stoklarında, Renault ve Dacia araçlar için 1400'ün üzerinde farklı parça çeşidi bulunuyor. Hem orijinal hem de kaliteli muadil seçenekleri bir arada sunarak, müşterilerimize bütçesine ve beklentisine göre seçim özgürlüğü tanıyoruz. Markaya sadık kalmak isteyene orijinalini, ekonomik çözüm arayana ise güvenilir muadilini öneriyoruz.",
        "Filtrelerden fren sistemine, süspansiyondan motor parçalarına kadar bir aracın ihtiyaç duyabileceği hemen her kategoride geniş stok tutuyoruz. Öne çıkan ürün kategorilerimizi aşağıda bulabilirsiniz:",
      ],
      bullets: [
        "Filtreler: Polen filtresi, yağ filtresi, hava filtresi ve yakıt filtresi",
        "Fren Sistemi: Fren balatası, fren diski ve kampana, kaliper, fren merkezi ile hidrolik ve hortumları",
        "Süspansiyon ve Direksiyon: Amortisör, salıncak ve tabla, rot ve rotil, aks ve körük, rulman ve bilya, viraj ve helezon",
        "Motor Parçaları: Triger ve eksantrik setleri, kayış ve kasnak, enjeksiyon ve yakıt besleme, conta ve subap, su pompası ve termostat, motor takozu",
        "Soğutma ve Isıtma: Radyatör, fan ve pervane, kalorifer, klima parçaları, su deposu ve hortumları",
        "Şanzıman ve Debriyaj: Debriyaj seti ve parçaları, vites kumanda, şanzıman takozları",
        "Elektrik ve Ateşleme: Buji ve buji kablosu, ateşleme bobini, marş ve alternatör, sigorta, kilit ve kontak",
        "Sensör ve Müşürler, Aydınlatma (far, stop, sinyal, ampul), Kaporta ve Cam, Silecek Sistemi, Egzoz Sistemi ile Yağ ve Kimyasallar",
      ],
    },
    {
      heading: "Desteklediğimiz Renault ve Dacia Modelleri",
      paragraphs: [
        "Stoklarımız, Renault ve Dacia'nın hem güncel hem de klasik geniş model yelpazesini kapsar. Yıllar içinde Türkiye yollarının emektarı haline gelen klasiklerden en yeni modellere kadar geniş bir araç gamına parça temin ediyoruz.",
        "Renault tarafında: Clio, Symbol, Megane, Scenic, Fluence, Laguna, Kangoo, Twingo, Modus, Captur, Latitude, Master ve Trafic modellerinin yanı sıra; R-9, R-11, R-12 Toros, R-19 ve R-21 gibi klasiklere de hizmet veriyoruz. Dacia tarafında ise Logan, Sandero, Duster, Dokker ve Lodgy modelleri için kapsamlı parça stoğu bulunduruyoruz.",
        "Aracınızın yılını ve motor tipini bildirmeniz, size en uygun parçayı hızlıca bulmamız için yeterlidir. Hem eski hem yeni nesil araçlara aynı uzmanlıkla yaklaşıyoruz.",
      ],
    },
    {
      heading: "Neden İrem Oto?",
      paragraphs: [
        "Ankara'da Renault ve Dacia yedek parça denildiğinde İrem Oto'yu tercih etmeniz için pek çok somut neden var. Tecrübemizi, stok genişliğimizi ve hizmet anlayışımızı tek bir çatı altında topluyoruz:",
      ],
      bullets: [
        "25 Yılı Aşkın Tecrübe: Çeyrek asrı aşan sektör birikimiyle, en zor parça taleplerinde bile çözüm üretiyoruz.",
        "Geniş ve Güncel Stok: 1400'ün üzerinde parça çeşidiyle aradığınızı çoğu zaman tek seferde buluyoruz.",
        "Doğru Parça Eşleştirme: Aracınızın model, yıl ve motor bilgisine göre tam uyan parçayı buluyor, yanlış parça riskini ortadan kaldırıyoruz.",
        "Orijinal ve Muadil Seçenek: Bütçenize ve beklentinize göre orijinal veya kaliteli muadil arasında özgürce seçim yapabilirsiniz.",
        "Hızlı ve Güler Yüzlü Hizmet: Uzman ekibimiz, ihtiyacınızı hızlıca anlar ve zaman kaybetmeden çözüme ulaştırır.",
        "Uygun Fiyat: Doğrudan ve verimli çalışma yapımız sayesinde rekabetçi fiyatlar sunuyoruz.",
      ],
    },
    {
      heading: "Konum ve Ulaşım: Ankara Yenimahalle Merkez Sanayi Sitesi",
      paragraphs: [
        "İrem Oto, Ankara'nın otomotiv yedek parça merkezlerinden Merkez Sanayi Sitesi'nde, kolay ulaşılabilir bir konumda hizmet vermektedir. Ankara ve çevresinden Renault veya Dacia yedek parça arayan tüm müşterilerimizi dükkanımıza bekliyoruz. Yenimahalle başta olmak üzere Ankara'nın her semtinden bize rahatlıkla ulaşabilirsiniz.",
        "Adres: Merkez Sanayi Sitesi 1344. Cadde 19/A, Yenimahalle / Ankara.",
        "Telefon: 0312 395 22 25 numaralı hattımızdan bize ulaşarak aracınıza uygun parça hakkında bilgi alabilir, stok durumunu öğrenebilirsiniz.",
        "Çalışma Saatlerimiz: Pazartesi - Cumartesi günleri 08:30 - 18:00 saatleri arasında hizmetinizdeyiz. Pazar günleri kapalıyız. Yalnızca tezgah başında değil, telefonla da size en doğru parçayı bulmak için yardımcı olmaktan memnuniyet duyarız.",
      ],
    },
  ],
  faq: [
    { q: "İrem Oto nerede, nasıl ulaşabilirim?", a: "İrem Oto, Merkez Sanayi Sitesi 1344. Cadde 19/A, Yenimahalle / Ankara adresinde hizmet vermektedir. Bize 0312 395 22 25 numaralı telefondan ulaşabilir; Pazartesi - Cumartesi 08:30 - 18:00 saatleri arasında dükkanımıza gelebilirsiniz. Pazar günleri kapalıyız." },
    { q: "Renault için hangi yedek parçalar mevcut?", a: "Renault araçlar için filtreler, fren sistemi, süspansiyon ve direksiyon, motor parçaları, soğutma-ısıtma, şanzıman-debriyaj, elektrik-ateşleme, sensör, aydınlatma, kaporta-cam, egzoz ile yağ ve kimyasallar dahil 1400'ü aşkın farklı parça çeşidi bulunuyor. Clio, Symbol, Megane, Scenic, Fluence, Laguna, Kangoo gibi güncel modellerin yanı sıra R-9, R-12 Toros, R-19 gibi klasiklere de parça temin ediyoruz." },
    { q: "Orijinal parça mı, muadil parça mı satıyorsunuz?", a: "Her ikisini de sunuyoruz. İrem Oto'da hem orijinal hem de kaliteli muadil yedek parça seçenekleri bir arada bulunur. Bütçenize ve beklentinize göre size en uygun seçeneği öneriyor, kararı sizinle birlikte veriyoruz." },
    { q: "Dacia için yedek parça bulabilir miyim?", a: "Evet. İrem Oto, Renault'nun yanı sıra Dacia konusunda da uzmanlaşmıştır. Logan, Sandero, Duster, Dokker ve Lodgy modelleri için orijinal ve muadil yedek parça stoğumuz mevcuttur. Ankara Dacia yedek parça ihtiyaçlarınız için doğru adrestesiniz." },
    { q: "Aracıma uygun parçayı bulmak için ne yapmam gerekiyor?", a: "Aracınızın markası (Renault veya Dacia), modeli, üretim yılı ve motor tipini bize iletmeniz yeterli. 25 yılı aşkın tecrübemizle, bu bilgilere göre aracınıza tam uyan doğru parçayı buluyor, yanlış parça riskini ortadan kaldırıyoruz." },
    { q: "Klasik Renault modelleri için parça var mı?", a: "Evet. R-9, R-11, R-12 Toros, R-19 ve R-21 gibi klasik Renault modelleri için de parça temin ediyoruz. Çeyrek asrı aşan tecrübemiz, özellikle bu emektar araçların parçalarını bulmada bize önemli bir avantaj sağlıyor." },
  ],
};

const SITE = 'https://renaultiremoto.com';
const ogImage = (typeof window !== 'undefined' ? window.location.origin : SITE) + '/logo.png';

const businessJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AutoPartsStore',
  name: 'İrem Oto',
  alternateName: 'İrem Otomotiv',
  description: ABOUT.seo.metaDescription,
  url: `${SITE}/hakkimizda`,
  telephone: '+90 312 395 22 25',
  image: ogImage,
  priceRange: '₺₺',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Merkez Sanayi Sitesi 1344. Cadde 19/A',
    addressLocality: 'Yenimahalle',
    addressRegion: 'Ankara',
    addressCountry: 'TR',
  },
  geo: { '@type': 'GeoCoordinates', latitude: 39.993939, longitude: 32.760615 },
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    opens: '08:30', closes: '18:00',
  }],
  areaServed: { '@type': 'City', name: 'Ankara' },
  knowsAbout: [
    'Renault yedek parça', 'Dacia yedek parça', 'Renault Clio', 'Renault Megane',
    'Renault Kangoo', 'Renault Fluence', 'Dacia Logan', 'Dacia Duster', 'Dacia Sandero',
    'orijinal yedek parça', 'muadil yedek parça',
  ],
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: ABOUT.faq.map(f => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

const Hakkimizda = () => {
  return (
    <>
      <SeoHead
        title="Hakkımızda"
        description={ABOUT.seo.metaDescription}
        keywords={ABOUT.seo.keywords}
        image={ogImage}
        jsonLd={[businessJsonLd, faqJsonLd]}
      />

      {/* Hero */}
      <Box sx={{ backgroundColor: '#1e2128', py: { xs: 6, md: 8 }, textAlign: 'center', color: 'white' }}>
        <Container maxWidth="md">
          <Typography variant="overline" sx={{ color: '#f08a0c', fontWeight: 700, letterSpacing: 2 }}>
            HAKKIMIZDA
          </Typography>
          <Typography component="h1" variant="h4" fontWeight={800} sx={{ mt: 1, lineHeight: 1.3 }}>
            {ABOUT.h1}
          </Typography>
          <Typography variant="body1" sx={{ color: '#bbb', mt: 2, maxWidth: 720, mx: 'auto', lineHeight: 1.8 }}>
            {ABOUT.heroSubtitle}
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
        {/* Highlights */}
        <Grid container spacing={2} sx={{ mb: { xs: 4, md: 6 } }}>
          {ABOUT.highlights.map((h, i) => (
            <Grid item xs={6} md={3} key={i}>
              <Paper elevation={0} sx={{ p: 3, textAlign: 'center', border: '1px solid #f0f0f0', borderRadius: 3, height: '100%' }}>
                <Typography variant="h5" fontWeight={800} sx={{ color: '#f08a0c', lineHeight: 1.2 }}>
                  {h.stat}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                  {h.label}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Sections */}
        {ABOUT.sections.map((sec, i) => (
          <Box key={i} sx={{ mb: { xs: 4, md: 5 } }}>
            <Typography component="h2" variant="h5" fontWeight={700} gutterBottom
              sx={{ borderLeft: '4px solid #f08a0c', pl: 1.5 }}>
              {sec.heading}
            </Typography>
            {sec.paragraphs.map((p, j) => (
              <Typography key={j} variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.9, mb: 1.5 }}>
                {p}
              </Typography>
            ))}
            {sec.bullets && (
              <List dense sx={{ mt: 0.5 }}>
                {sec.bullets.map((b, k) => (
                  <ListItem key={k} disableGutters alignItems="flex-start" sx={{ py: 0.25 }}>
                    <ListItemIcon sx={{ minWidth: 32, mt: '4px' }}>
                      <CheckCircleIcon sx={{ fontSize: 20, color: '#f08a0c' }} />
                    </ListItemIcon>
                    <ListItemText primary={b} primaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }} />
                  </ListItem>
                ))}
              </List>
            )}
          </Box>
        ))}

        <Divider sx={{ my: { xs: 4, md: 5 } }} />

        {/* SSS */}
        <Typography component="h2" variant="h5" fontWeight={700} gutterBottom sx={{ borderLeft: '4px solid #f08a0c', pl: 1.5, mb: 2 }}>
          Sıkça Sorulan Sorular
        </Typography>
        {ABOUT.faq.map((f, i) => (
          <Accordion key={i} disableGutters elevation={0} sx={{ border: '1px solid #eee', '&:before': { display: 'none' }, mb: 1, borderRadius: 2, overflow: 'hidden' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight={600}>{f.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>{f.a}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}

        {/* CTA */}
        <Paper elevation={0} sx={{ mt: { xs: 4, md: 6 }, p: { xs: 3, md: 4 }, textAlign: 'center', borderRadius: 3, backgroundColor: '#fff7ee', border: '1px solid #ffe2bf' }}>
          <Typography variant="h6" fontWeight={700} gutterBottom>
            Aracınıza uygun parçayı birlikte bulalım
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
            Geniş Renault ve Dacia yedek parça kataloğumuzu inceleyin veya doğrudan bize ulaşın.
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center">
            <Button variant="contained" size="large" startIcon={<StorefrontIcon />} component={Link} to="/urunler"
              sx={{ backgroundColor: '#f08a0c', '&:hover': { backgroundColor: '#d4780a' }, fontWeight: 600 }}>
              Ürün Kataloğu
            </Button>
            <Button variant="outlined" size="large" startIcon={<PhoneIcon />} href="tel:03123952225"
              sx={{ color: '#f08a0c', borderColor: '#f08a0c', fontWeight: 600, '&:hover': { borderColor: '#d4780a', backgroundColor: '#fff' } }}>
              0312 395 22 25
            </Button>
          </Stack>
        </Paper>
      </Container>
    </>
  );
};

export default Hakkimizda;
